<template>
    <van-form>
        <van-field v-model="phone" required label="手机号" clearable placeholder="请输入手机号" />
        <van-field v-model="verification_code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
                <van-button size="small" type="primary" @click="sendSms" :disabled="!!send_interval">{{send_interval ? send_interval + 's后重试' : '发送验证码'}}</van-button>
            </template>
        </van-field>
        <van-button type="primary" block style="margin-top: 20px;" @click="bind">绑定</van-button>
    </van-form>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";

    export default {
        name: "BindPhone",
        data(){
            return {
                phone : '',
                verification_code : '',
                send_interval : null,
            };
        },
        methods : {
            sendSms(){
                let self = this;
                api.request('/common/send_sms_verification_code', {
                    'phone' : this.phone,
                    'type' : 'bind_phone',
                }).then(res => {
                    self.send_interval = res.data.send_interval;
                    let setSmsTimer = setInterval(function () {
                        self.send_interval--;
                        if(self.send_interval <= 0){
                            clearInterval(setSmsTimer);
                            self.send_interval = null;
                        }
                    }, 1000);
                    self.$toast(res.msg);
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            bind(){
                let self = this;
                api.request('/user/bind_phone', {
                    phone : this.phone,
                    verification_code : this.verification_code,
                }).then(res => {
                    self.$toast(res.msg);
                    self.$store.commit('refreshUserInfo');  //同步用户信息
                    self.$router.back();
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/BindPhone.vue